export const NOT_FOUND = 404;
export const NOT_ACCEPTABLE = 406;
export const UNPROCESSABLE_ENTITY = 422;
export const UNAUTHORIZED = 401;
export const FORBIDDEN = 403;
export const GATEWAY_TIMEOUT = 504;
export const NO_SEATS = 1002;
export const EMAIL_LINKED_TO_ANOTHER_ACCOUNT = 2007;
